import {
	COPYRIGHT,
	대표자명,
	사업자등록번호,
	업체명,
	이메일,
	전화번호,
	정보책임자,
	주소
} from '@/constants/infos';
import './footer.scss';
import { menuList } from '@/data/navigation';
import paths from '@/routes/paths';
import { ReactComponent as MainLogo } from '@/assets/icons/svg/common/main-logo.svg';
import { ReactComponent as FooterMap } from '@/assets/icons/svg/footer/footer-map.svg';
import { ReactComponent as FooterBlog } from '@/assets/icons/svg/footer/footer-blog.svg';
import { ReactComponent as FooterInstagram } from '@/assets/icons/svg/footer/footer-instagram.svg';
import { ReactComponent as FooterContact } from '@/assets/icons/svg/footer/footer-contact.svg';
import { Link } from 'react-router-dom';
import {
	네이버_지도_링크,
	블로그_링크,
	인스타그램_링크
} from '@/constants/links';

const Footer = () => {
	const handleClickEmail = () => {
		window.open(`mailto:${이메일}`, '_blank');
	};

	const handleClickPhone = () => {
		const telWithoutDash = 전화번호.replace(/-/g, '');
		window.open(`tel:${telWithoutDash}`, '_blank');
	};

	return (
		<footer className="footer-wrapper">
			<section className="foot-contents-wrapper">
				<div className="footer-top">
					<article className="main-logo-wrapper">
						<MainLogo />
					</article>
					<nav
						className="footer-sitemap"
						aria-label="푸터 사이트맵"
						data-analytics-section="footer_navigation"
						data-analytics-label="사이트맵"
					>
						{menuList.map((menu) => (
							<div className="footer-menu-group" key={menu.id}>
								<h2>{menu.label}</h2>
								{(
									menu.subMenu || [
										{
											id: menu.id,
											label: menu.label,
											path: menu.path
										}
									]
								).map((link) => (
									<Link
										key={link.id}
										to={link.path}
										data-analytics-cta={`footer_navigation_${link.id}`}
										data-analytics-label={link.label}
									>
										{link.label}
									</Link>
								))}
							</div>
						))}
						<div className="footer-menu-group">
							<h2>문의</h2>
							<Link
								className="footer-inquiry-link"
								to={paths.inquiry}
								data-analytics-cta="footer_navigation_inquiry"
							>
								문의하기 <span aria-hidden="true">↗</span>
							</Link>
						</div>
					</nav>
				</div>
				<div className="divider-horizontal" />
				<div className="footer-bottom">
					<article className="info-wrapper">
						<div className="info-line">
							<p>{`업체명 : ${업체명}`}</p>
							<div className="divider" />
							<p
								data-analytics-cta="footer_phone"
								data-analytics-label="전화 문의"
								onClick={handleClickPhone}
								className="phone-link"
							>
								{`전화번호 : ${전화번호}`}
							</p>
							<div className="divider" />
							<p>{`대표자명 : ${대표자명}`}</p>
							<div className="divider" />
							<p>{`사업자등록번호 : ${사업자등록번호}`}</p>
						</div>
						<div className="info-line">
							<p>{`주소 : ${주소}`}</p>
							<div className="divider" />
							<p>{`정보책임자 : ${정보책임자}`}</p>
							<div className="divider" />
							<p
								data-analytics-cta="footer_email_text"
								data-analytics-label="이메일 문의"
								onClick={handleClickEmail}
								className="email-link"
							>
								{`이메일 : ${이메일}`}
							</p>
						</div>
					</article>
					<article className="sns-wrapper">
						<Link
							data-analytics-cta="footer_map"
							data-analytics-label="지도 보기"
							to={네이버_지도_링크}
							aria-label="네이버 지도로 이동"
						>
							<FooterMap />
						</Link>
						<div className="sns-divider" />
						<Link
							data-analytics-cta="footer_blog"
							data-analytics-label="블로그 보기"
							to={블로그_링크}
							aria-label="블로그로 이동"
						>
							<FooterBlog />
						</Link>
						<div className="sns-divider" />
						<Link
							data-analytics-cta="footer_instagram"
							data-analytics-label="인스타그램 보기"
							to={인스타그램_링크}
							aria-label="인스타그램으로 이동"
						>
							<FooterInstagram />
						</Link>
						<div className="sns-divider" />
						<button
							onClick={handleClickEmail}
							aria-label="이메일로 문의하기"
							data-analytics-cta="footer_email"
							data-analytics-label="이메일로 문의하기"
						>
							<FooterContact />
						</button>
					</article>
				</div>
				<p className="copyright">{COPYRIGHT}</p>
			</section>
		</footer>
	);
};

export default Footer;
